import { OfferFragment } from '@occc/graphql';
import { makePreAuthConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { Operation } from '@occc-app/offerHelpers/types';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

export const getPreAuthConstraintOperations = (
  offer: OfferFragment | null | undefined,
): Operation[] => {
  const operations: Operation[] = [];

  if (!offer) {
    return operations;
  }

  const offerId = offer.id;
  const authConstraint = offer.constraints.find(constraintHelper.isPreAuth);

  if (!authConstraint) {
    const preAuthConstraint = makePreAuthConstraintOperation(offerId);
    operations.push(preAuthConstraint);
  }

  return operations;
};
